const premiumPlans = [
  { duration: '1 Month', price: '14', monthly: '≈ 14 USD/month', badge: null, bonus: null },
  { duration: '3 Months', price: '29', monthly: '≈ 9.67 USD/month', badge: null, bonus: null },
  { duration: '6 Months', price: '45', monthly: '≈ 7.50 USD/month', badge: 'SAVE 33%', bonus: null },
  { duration: '12 Months', price: '65', monthly: '≈ 5.42 USD/month', badge: 'SAVE 50%', bonus: '🎁 2nd sub at 45 USD' },
];

const goldPlans = [
  { duration: '1 Month', price: '17', monthly: '≈ 17 USD/month', badge: null, featured: false },
  { duration: '3 Months', price: '35', monthly: '≈ 11.67 USD/month', badge: null, featured: false },
  { duration: '6 Months', price: '55', monthly: '≈ 9.17 USD/month', badge: 'SAVE 33%', featured: false },
  { duration: '12 Months', price: '80', monthly: '≈ 6.67 USD/month', badge: 'SAVE 50%', featured: true },
];

const premiumFeatures = [
  'HD/4K quality on all your screens',
  '1 app included if device is compatible',
  '1 device connected simultaneously',
  'Immediate activation in 5 min',
  'WhatsApp support 7 days/7',
  'Compatible Smart TV, Box, Mobile, PC',
  'Automatic updates',
  'International channels included',
];

const goldFeatures = [
  '4K Ultra HD premium quality',
  '1 app included if device is compatible',
  '1 device connected simultaneously',
  'Exclusive Anti-Freeze technology',
  '24h Replay on select channels',
  'Complete EPG electronic guide',
  'Priority support 7 days/7',
  'Compatible with all devices',
  'Automatic updates',
  'Premium international content',
  'Extensive VOD library included',
  'Immediate activation in 5 min',
];

const WA = 'https://wa.me/12057092376';

const Pricing = () => (
  <section id="pricing" className="py-10 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
    <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-[#862ce0]/5 rounded-full blur-[120px] pointer-events-none"></div>
    <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none"></div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12">
        <span className="inline-block bg-white/5 text-gray-300 border border-white/10 text-xs px-4 py-1 rounded-full mb-4 font-medium">
          💎 Exclusive Offers
        </span>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white mb-2 tracking-tight">
          Premium Streaming Subscription
        </h2>
        <p className="text-xs sm:text-sm text-gray-500 max-w-xl mx-auto">
          🎥 Unlimited access to a vast library of Movies &amp; Series + thousands of live TV channels — Guaranteed 4K quality without interruption!
        </p>
      </div>

      {/* PREMIUM */}
      <div className="max-w-5xl mx-auto mb-8 sm:mb-10">
        <div className="rounded-3xl border border-[#862ce0]/25 bg-gradient-to-b from-gray-900/95 to-gray-950 p-5 sm:p-8 relative overflow-hidden">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[350px] h-[220px] bg-[#862ce0]/10 rounded-full blur-[100px] pointer-events-none"></div>

          <div className="text-center mb-6 relative z-10">
            <span className="inline-block bg-[#862ce0]/10 text-[#b47ef3] border border-[#862ce0]/35 text-xs px-5 py-1.5 rounded-full mb-3 font-bold tracking-wide">
              PREMIUM
            </span>
            <h3 className="text-2xl sm:text-3xl font-black text-white mb-1">Premium Offer</h3>
            <p className="text-xs sm:text-sm text-gray-500">The essentials of quality streaming</p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 mb-5 relative z-10">
            {[
              { icon: 'ri-tv-line', value: '25,000+', label: 'HD/4K Channels' },
              { icon: 'ri-movie-2-line', value: '35,000+', label: 'Movies & Series' },
              { icon: 'ri-apps-line', value: '1 App', label: 'Included if device is compatible' },
              { icon: 'ri-wifi-line', value: 'Stable', label: 'Connection' },
            ].map((s) => (
              <div key={s.label} className="text-center bg-gray-800/60 border border-[#862ce0]/15 rounded-xl p-2.5 sm:p-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 mx-auto rounded-lg sm:rounded-xl bg-gradient-to-br from-[#862ce0]/25 to-[#c026d3]/15 flex items-center justify-center mb-1.5">
                  <i className={`${s.icon} text-[#b47ef3]`}></i>
                </div>
                <p className="text-xs sm:text-base font-black text-white">{s.value}</p>
                <p className="text-[9px] sm:text-xs text-gray-500">{s.label}</p>
              </div>
            ))}
          </div>

          {/* Features */}
          <div className="grid grid-cols-2 gap-x-3 gap-y-1 sm:gap-x-4 sm:gap-y-1.5 mb-5 relative z-10 bg-gray-800/30 rounded-xl p-3 sm:p-4 border border-white/5">
            {premiumFeatures.map((f) => (
              <div key={f} className="flex items-center gap-1">
                <i className="ri-check-line text-[#b47ef3] text-xs flex-shrink-0"></i>
                <span className="text-[10px] sm:text-sm text-gray-300 leading-tight">{f}</span>
              </div>
            ))}
          </div>

          {/* Plans */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 relative z-10">
            {premiumPlans.map((plan) => (
              <div key={plan.duration} className="relative rounded-2xl p-[1px] bg-gradient-to-b from-[#862ce0]/30 to-[#862ce0]/8 hover:scale-[1.02] transition-all duration-300">
                {plan.badge && (
                  <div className="absolute -top-2.5 left-0 right-0 flex justify-center z-10">
                    <span className="bg-gradient-to-r from-[#862ce0] to-[#c026d3] text-white text-[11px] px-3 py-0.5 rounded-full shadow-lg font-bold">
                      {plan.badge}
                    </span>
                  </div>
                )}
                <div className="rounded-2xl p-2.5 sm:p-4 h-full flex flex-col items-center text-center bg-gray-900/95">
                  <p className="text-[10px] sm:text-xs font-bold uppercase tracking-widest mb-1 sm:mb-2 text-[#b47ef3]">{plan.duration}</p>
                  <div className="flex items-baseline my-0.5 sm:my-1">
                    <span className="text-2xl sm:text-4xl font-black text-white tracking-tight">{plan.price}</span>
                    <span className="text-gray-400 text-[10px] sm:text-sm ml-0.5 font-medium">USD</span>
                  </div>
                  <p className="text-[9px] sm:text-[11px] text-[#b47ef3]/70 mb-2 sm:mb-3">{plan.monthly}</p>
                  {plan.bonus && (
                    <div className="w-full mb-2 p-1.5 sm:p-2 rounded-lg bg-gradient-to-r from-emerald-500/10 to-green-500/10 border border-emerald-500/20">
                      <p className="text-[9px] sm:text-[11px] font-bold text-emerald-400">{plan.bonus}</p>
                    </div>
                  )}
                  <a
                    href={WA}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-3 py-2 w-full h-8 sm:h-10 rounded-lg sm:rounded-xl font-bold text-[10px] sm:text-sm bg-[#862ce0]/15 hover:bg-[#862ce0]/30 text-[#b47ef3] border border-[#862ce0]/35 transition-all duration-300 mt-auto cursor-pointer flex items-center justify-center whitespace-nowrap"
                  >
                    🛒 Buy Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-5xl mx-auto mb-8 sm:mb-10">
        <div className="flex items-center gap-3">
          <div className="flex-1 border-t border-white/10"></div>
          <span className="text-gray-600 text-[10px] sm:text-xs font-medium uppercase tracking-widest whitespace-nowrap">⬆ PREMIUM GOLD</span>
          <div className="flex-1 border-t border-white/10"></div>
        </div>
      </div>

      {/* PREMIUM GOLD */}
      <div className="max-w-5xl mx-auto mb-8 sm:mb-12">
        <div className="rounded-3xl border-2 border-amber-500/30 bg-gradient-to-b from-gray-900 via-gray-950 to-gray-900 p-5 sm:p-8 pt-8 sm:pt-10 relative overflow-hidden">
          <div className="absolute top-0 left-1/4 w-[250px] h-[250px] bg-amber-500/8 rounded-full blur-[100px] pointer-events-none"></div>
          <div className="absolute bottom-0 right-1/4 w-[200px] h-[200px] bg-orange-500/5 rounded-full blur-[80px] pointer-events-none"></div>

          <div className="flex justify-center mb-4 relative z-20">
            <span className="bg-gradient-to-r from-amber-400 to-orange-500 text-white text-xs px-5 py-1.5 rounded-full shadow-xl shadow-amber-500/30 font-bold">
              RECOMMENDED
            </span>
          </div>

          <div className="text-center mb-6 relative z-10">
            <span className="inline-block bg-amber-500/10 text-amber-400 border border-amber-500/30 text-xs px-5 py-1.5 rounded-full mb-3 font-bold tracking-wide">
              PREMIUM GOLD
            </span>
            <h3 className="text-2xl sm:text-3xl font-black text-white mb-1">
              Premium <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-400">GOLD</span>
            </h3>
            <p className="text-xs sm:text-sm text-gray-400 mb-2">The ultimate streaming experience • All included</p>
            <p className="text-sm sm:text-base text-amber-300/90 font-medium max-w-xl mx-auto leading-relaxed">
              Enjoy unlimited access to <b>35,000+ live channels</b> and an extensive library of <b>movies and series</b>
            </p>
          </div>

          {/* Gold Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 mb-5 relative z-10">
            {[
              { icon: 'ri-tv-2-line', value: '35,000+', label: '4K Channels' },
              { icon: 'ri-film-line', value: '70,000+', label: 'Movies & Series' },
              { icon: 'ri-apps-2-line', value: '1 App', label: 'On 1 device if device is compatible' },
              { icon: 'ri-shield-flash-line', value: 'Anti-Freeze', label: 'Technology' },
            ].map((s) => (
              <div key={s.label} className="text-center bg-gray-800/60 border border-amber-500/10 rounded-xl p-2.5 sm:p-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 mx-auto rounded-lg sm:rounded-xl bg-gradient-to-br from-amber-500/20 to-orange-600/10 flex items-center justify-center mb-1.5">
                  <i className={`${s.icon} text-amber-400`}></i>
                </div>
                <p className="text-xs sm:text-base font-black text-white">{s.value}</p>
                <p className="text-[9px] sm:text-xs text-gray-500">{s.label}</p>
              </div>
            ))}
          </div>

          {/* Gold Features */}
          <div className="mb-5 relative z-10 bg-gradient-to-r from-amber-500/5 to-orange-500/5 rounded-xl p-3 sm:p-4 border border-amber-500/15">
            <p className="text-[11px] sm:text-xs font-bold text-amber-400 mb-2 sm:mb-3 flex items-center gap-1.5">
              <i className="ri-star-line"></i> PREMIUM GOLD
            </p>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1 sm:gap-x-4 sm:gap-y-1.5">
              {goldFeatures.map((f) => (
                <div key={f} className="flex items-center gap-1">
                  <i className="ri-check-line text-amber-400 text-xs flex-shrink-0"></i>
                  <span className="text-[10px] sm:text-sm text-gray-300 leading-tight">{f}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Comparison badge */}
          <div className="mb-6 relative z-10 text-center">
            <div className="inline-flex items-center gap-2 bg-gray-800/60 rounded-full px-4 py-2 border border-white/5">
              <span className="text-[11px] sm:text-xs text-gray-400">Premium: 1 App</span>
              <span className="text-amber-400 text-sm">→</span>
              <span className="text-[11px] sm:text-xs font-bold text-amber-400">Gold: 3 Apps on the same device</span>
            </div>
          </div>

          {/* Gold Plans */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 relative z-10">
            {goldPlans.map((plan) => (
              <div
                key={plan.duration}
                className={`relative rounded-2xl transition-all duration-300 hover:scale-[1.02] ${
                  plan.featured
                    ? 'p-[2px] bg-gradient-to-b from-amber-400 via-orange-400 to-amber-600 shadow-2xl shadow-amber-500/20'
                    : 'p-[1px] bg-gradient-to-b from-amber-500/25 to-amber-500/5'
                }`}
              >
                {plan.badge && (
                  <div className="absolute -top-2.5 left-0 right-0 flex justify-center gap-2 z-10">
                    <span className="bg-gradient-to-r from-amber-400 to-orange-500 text-white text-[11px] px-3 py-0.5 rounded-full shadow-lg font-bold">
                      {plan.badge}
                    </span>
                    {plan.featured && (
                      <span className="bg-gray-900 text-white text-[11px] px-3 py-0.5 rounded-full shadow-lg border border-amber-500/50">N°1</span>
                    )}
                  </div>
                )}
                <div className={`rounded-2xl p-2.5 sm:p-4 h-full flex flex-col items-center text-center ${plan.featured ? 'bg-gray-950' : 'bg-gray-900/95'}`}>
                  <p className="text-[10px] sm:text-xs font-bold uppercase tracking-widest mb-1 sm:mb-2 text-amber-400">{plan.duration}</p>
                  <div className="flex items-baseline my-0.5 sm:my-1">
                    <span className="text-2xl sm:text-4xl font-black text-white tracking-tight">{plan.price}</span>
                    <span className="text-gray-400 text-[10px] sm:text-sm ml-0.5 font-medium">USD</span>
                  </div>
                  <p className="text-[9px] sm:text-[11px] text-amber-400/70 mb-1.5 sm:mb-2">{plan.monthly}</p>
                  <span className="inline-block bg-amber-500/10 text-amber-400 border border-amber-500/20 text-[8px] sm:text-[10px] px-1.5 sm:px-2.5 py-0.5 rounded-full mb-2 sm:mb-3 font-medium">
                    Replay 24h
                  </span>
                  <a
                    href={WA}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`px-3 py-2 w-full h-8 sm:h-10 rounded-lg sm:rounded-xl font-bold text-[9px] sm:text-sm transition-all duration-300 mt-auto flex items-center justify-center whitespace-nowrap cursor-pointer ${
                      plan.featured
                        ? 'bg-gradient-to-r from-amber-400 to-orange-500 hover:opacity-90 text-white shadow-lg shadow-amber-500/20'
                        : 'bg-amber-500/15 hover:bg-amber-500/25 text-amber-300 border border-amber-500/30'
                    }`}
                  >
                    {plan.featured ? '🔥 Buy Now' : '🛒 Buy Now'}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Pricing;
